var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.314 11.314a5.656 5.656 0 005.657-5.657A5.656 5.656 0 0011.314 0a5.656 5.656 0 00-5.657 5.657 5.656 5.656 0 005.657 5.657zm0 2.829C7.538 14.143 0 16.038 0 19.8v2.829h22.629V19.8c0-3.762-7.539-5.657-11.315-5.657z"
  })));
}
export default SvgPerson;